import BaseAPI from '../base'
//模型
class DashboardService extends BaseAPI {
  addToDashboard(body) {
    return this.post({
      url: '/home',
      data: body,
    })
  }

  // 查询首页渠道列表信息
  getChannels() {
    return this.get({
      url: '/channel',
    })
  }

  // 获取渠道数据
  getChannelStatistics(channels) {
    return this.get({
      url: '/channel/statistics',
      params: { channels },
    })
  }

  // 查询首页布局
  getDashboardList(status, dashboardUid = '') {
    return this.get({
      url: '/home',
      params: { dashboardUid, status },
    })
  }

  // 获取首页dashboard列表
  fetchDashboards() {
    return this.get({
      url: '/dashboard/list',
    })
  }

  // 获取首页dashboardIcon列表
  fetchDashboardsIcon() {
    return this.get({
      url: '/data-source/group/channels',
    })
  }
  // 导出详细分析数据
  fetchDashData(data) {
    return this.post({
      url: `/data-source/export/large-plot`,
      data,
    })
  }
  //竞对排名
  fetchCsiData(data) {
    return this.post({
      url: `/group/hotel/competition/rank/list`,
      data,
    })
  }
  //竞对排名
  exportGroupCsiData(data) {
    return this.post({
      url: `/group/hotel/competition/rank/export`,
      data,
    })
  }
  exportAllCsiData(data) {
    return this.post({
      url: `/group/hotel/competition/rank/export-all`,
      data,
    })
  }

  // 提交给服务端 /export/excel/byQuery

  exportExcelByQuery(data) {
    return this.post({
      url: `http://127.0.0.1:3301/export/excel/byQuery`,
      data,
    })
  }
}

export default new DashboardService()
